import { render, staticRenderFns } from "./BirthdayInputForm.vue?vue&type=template&id=004b88ce&scoped=true&"
import script from "./BirthdayInputForm.vue?vue&type=script&lang=js&"
export * from "./BirthdayInputForm.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayInputForm.vue?vue&type=style&index=0&id=004b88ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b88ce",
  null
  
)

export default component.exports